import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Vehiculo, Conductor } from '../modelos/data-emision.model';
import { StorageService } from '../services/storage.service';
import { ValidaRFC } from '../utilities/validaRFC';
import { CocheSeguro } from '../modelos/cocheSeguro.model';
import { LogConsumoFunciones } from '../utilities/logConsumo';
import { RequestServices } from '../services/request.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CotizacionAyudaComponent } from '../cotizacion/ayuda/cotizacion-ayuda.component';
import { MatDialog } from '@angular/material/dialog';
import { Configuration } from '../Constants/configuration';
import { validaSerie } from '../utilities/valida-noSerie';
import { StyleCocheSeguro } from '../modelos/styleCocheseguro.model';
import { SimpleMessageComponent } from '../tools/simple-message/simple-message.component';
import { finalize, min } from 'rxjs/operators';
import { Prospecto } from '../modelos/prospecto.model';
import { OpcionesSeguros } from './components/opciones-seguros.component';
import { FormControl } from '@angular/forms';
import { ValidacionesReactiveForm } from '../utilities/validacionesReactiveForm';
import { ValorCodigoPromocion } from '../modelos/valor-codigo-promocion.model';

declare var gtag;

@Component({
  selector: 'datos-emision-vehiculo',
  templateUrl: './datos-emision-vehiculo.component.html',
  styleUrls: ['./datos-emision-vehiculo.component.css']
})
export class DatosEmisionVehiculoComponent {
  public const: Configuration = new Configuration();
  public styleCocheSeguro: StyleCocheSeguro = new StyleCocheSeguro();
  value: string = "";
  vehiculo: Vehiculo = new Vehiculo();
  conductor: Conductor = new Conductor();
  dataContratante: any = {};
  cia: number = 0;
  muestraOtroConcductor: number = 0;
  public logConsumoFun: LogConsumoFunciones = new LogConsumoFunciones(this.requestService, this.storageService, this.router);
  public validacionSerie: boolean = false;
  public validacionNoSerie: validaSerie = new validaSerie(this.requestService, this.storageService, this.router);
  public inputRef: boolean = false;
  public edadContratante: number = 0;
  public edadMismaProspecto: boolean = false;
  public edadMismaProspectoValid: boolean = false;
  public edadConductor: number = 0;
  public sexoContratante: number = 0;
  public sexoProspecto: number = 0;
  public sexoInput: string = '';
  public dataProspecto: Prospecto = new Prospecto();
  public correo: string = "";
  public inputRefSivale: boolean = false;
  public inputRefValido: boolean = false;
  public inputRefQA: boolean = false;
  conductorRef = new FormControl('');
  codPromocion = new FormControl('');
  isLoading: boolean;
  formaPago: string;
  inputRefInterMX: boolean;
  mostrarCodigoPromocion = false;
  public numSerie: boolean =true;
  placeholderMessageSerie: string = "";
  tipoVehiculo: number;

  constructor(private router: Router, private storageService: StorageService, private snackBar: MatSnackBar, private requestService: RequestServices, private modal: MatDialog) {
    if (this.storageService.ifExist("styleCocheSeguro")) {
      this.styleCocheSeguro = JSON.parse(this.storageService.getItem("styleCocheSeguro"));
    }

  }

  ngOnInit(): void {

    if(this.storageService.ifExist('codp')) {
      this.conductorRef.setValue(this.storageService.getItem('codp'));
      this.conductorRef.disable({onlySelf: true});
    }

    if(this.storageService.ifExist('formaPago')) {
      this.formaPago = JSON.parse(this.storageService.getItem('formaPago')).formaPago;
      
    }
    
    this.inputRefSivale = (window.location.hostname === 'cochesegurosivale.inter.mx') ? true : false; 
    this.inputRefQA = (window.location.hostname == 'inter-autos-qa.web.app') ? true : false;    
    this.inputRefInterMX = (window.location.hostname === 'cocheseguro.inter.mx') ? true : false; 
    
    this.logConsumoFun.logConsumo();
    gtag({ 'event': 'formStep3View' });
    let cocheSeguro: CocheSeguro = new CocheSeguro();
    if (this.storageService.ifExist("cocheSeguro")) {
      cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
      this.tipoVehiculo = cocheSeguro.dataVehiculo.multicotiza.f7;
      if (cocheSeguro.isNomina) {
        this.inputRef = true;
      }
    }

    if (cocheSeguro?.contratante) {
      this.dataProspecto = cocheSeguro.prospecto;
      this.correo = this.dataProspecto.correo;
    } else {
      this.dataProspecto = cocheSeguro.prospecto;
      this.correo = this.dataProspecto.correo;
    }
    if (cocheSeguro?.cia) {
      this.cia = cocheSeguro.cia;
    }
    this.dataContratante = cocheSeguro?.contratante;
    if (cocheSeguro?.conductor) {
      this.conductor = cocheSeguro.conductor;
      if (this.conductor.mismo_conductor) {
        this.muestraOtroConcductor = 1;
      } else {
        this.muestraOtroConcductor = 0;
      }
    } else {
      // if (this.cia != 49 && this.cia != 1) {
      if (!this.conductor.mismo_conductor) {
        this.conductor.nombres = this.dataContratante.nombres;
        this.conductor.ap_pat = this.dataContratante.ap_pat;
        this.conductor.ap_mat = this.dataContratante.ap_mat;
      } else {
        this.conductor.nombres = this.dataContratante.nombres;
        this.conductor.ap_pat = this.dataContratante.ap_pat;
        this.conductor.ap_mat = this.dataContratante.ap_mat;
        this.conductor.fec_nac = this.dataContratante.fec_nac;
        this.conductor.fec_nac_str = this.dataContratante.fec_nac_str;
        this.conductor.rfc = this.dataContratante.rfc;
      }
    }

    if (cocheSeguro?.vehiculo) {
      this.vehiculo = cocheSeguro?.vehiculo;
    }

    window.scrollTo(0, 0);
    this.sexoInput = cocheSeguro.prospecto.sexo == 0 ? 'Femenino' : 'Masculino';
    if (cocheSeguro.cia == 18) {
      this.conductor.sexo = cocheSeguro.prospecto.sexo == 0 ? 'F' : 'M';
      this.edadContratante = this.CalculateAge(cocheSeguro.contratante.fec_nac);
      this.sexoContratante = (cocheSeguro.contratante.sexo == 'F' ? 0 : 1);
      this.sexoProspecto = cocheSeguro.prospecto.sexo;
      this.edadConductor = cocheSeguro.edad;
      if (this.conductor.edad_cond_hab == undefined || this.conductor.edad_cond_hab == 0) {
        if (this.edadContratante == this.edadConductor && this.sexoProspecto == this.sexoContratante) {
          this.edadMismaProspectoValid = true;
          this.edadMismaProspecto = true;
          this.conductor.edad_cond_hab = this.edadConductor;
        } else {
          this.muestraOtroConcductor = 1;
          this.conductor.mismo_conductor = true;
          this.conductor.nombres = '';
          this.conductor.ap_pat = '';
          this.conductor.ap_mat = '';
          this.conductor.fec_nac = '';
          this.conductor.fec_nac_str = '';
          this.conductor.rfc = '';
        }
      } else if (this.conductor.edad_cond_hab != undefined || this.conductor.edad_cond_hab != 0) {
        if (this.edadContratante == this.edadConductor && this.sexoProspecto == this.sexoContratante) {
          this.edadMismaProspectoValid = true;
          this.edadMismaProspecto = true;
        } else {
          this.conductor.mismo_conductor = true;
        }
        this.isMismaEdad();
      }
    } else {
      this.conductor.sexo = cocheSeguro.prospecto.sexo == 0 ? 'F' : 'M';
    }

    this.workParams();
    //this.muestraCotizaciones();
  }

  public regexLettersAndNumbers: any = {
    mask: [
      {
        mask: /[a-zA-Z0-9]$/,
        regex: '[^A-Za-z0-9]'
      }
    ]
  }

  isMismaEdad() {
    let edadNueva: number = this.CalculateAge(this.conductor.fec_nac);
    if (edadNueva != this.edadConductor) {
      this.edadMismaProspecto = false;
      let simpleMess = this.modal.open(SimpleMessageComponent, { disableClose: true });
      simpleMess.componentInstance.accion = '';
      simpleMess.componentInstance.cancel = 'CERRAR';
      simpleMess.componentInstance.message = 'La edad debe ser igual a la capturada en la pantalla inicial.';
    } else {
      this.edadMismaProspecto = true;
      this.conductor.edad_cond_hab = this.edadConductor;
    }
  }

  CalculateAge(fecNac: string): number {
    if (fecNac.split('/').length >= 2) {
      const anio: number = parseInt(fecNac.split('/')[2]);
      const mes: number = parseInt(fecNac.split('/')[1]);
      const dia: number = parseInt(fecNac.split('/')[0]);
      const today: Date = new Date();
      const birthDate: Date = new Date(anio, mes, dia);
      let age: number = today.getFullYear() - birthDate.getFullYear();
      const month: number = (today.getMonth() + 1) - birthDate.getMonth();
      if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    } else {
      return 18;
    }
  }

  next() {
    let cocheSeguro: CocheSeguro = JSON.parse(this.storageService.getItem('cocheSeguro'));
    let negId: number = +this.storageService.getItem('negId')
    let params = {
      numeroDeSerie: this.vehiculo.serie,
      negocio_id: negId,
      jsonEntrada: {
        ...cocheSeguro
      }
    }

    cocheSeguro.vehiculo = this.vehiculo;
    cocheSeguro.conductor = this.conductor;
    cocheSeguro.prospecto = this.dataProspecto;
    if (cocheSeguro.cia !== 20 && cocheSeguro.cia !== 44 && cocheSeguro.cia !== 3){
    this.requestService.postRequest({ projectName: new Configuration().URLQUATTROAUTOSWS, apiName: 'valida-serie', dataJSON: params }).pipe(finalize(() => this.isLoading = false)).subscribe(
      response => {
        if(response.error) {
          this.validacionSerie = false;
          this.snackBar.open(response.error, "", { duration: this.const.SNACK_BARTIME })
        } else if (response.valid) {
            this.validacionSerie = true;
            let cocheSeguro: CocheSeguro = new CocheSeguro();
            if (this.storageService.ifExist("cocheSeguro")) {
              cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
            }
            if ((this.cia == 49 || this.cia == 1) && this.conductor.fec_nac != '') {
              let arr: Array<string> = this.conductor.fec_nac.split('/');
              if (arr.length == 3) {
                this.conductor.fec_nac_str = arr[2] + '-' + arr[1] + '-' + arr[0];
              }
            }
            if (!this.conductor.mismo_conductor) {
              this.conductor.nombres = this.dataContratante.nombres;
              this.conductor.ap_pat = this.dataContratante.ap_pat;
              this.conductor.ap_mat = this.dataContratante.ap_mat;
              this.conductor.rfc = cocheSeguro.contratante.rfc;
              this.conductor.fec_nac_str = cocheSeguro.contratante.fec_nac_str;
              this.conductor.fec_nac = cocheSeguro.contratante.fec_nac;
            }
        
            cocheSeguro.vehiculo = this.vehiculo;
            cocheSeguro.conductor = this.conductor;
            
            this.storageService.setItem("cocheSeguro", JSON.stringify(cocheSeguro));
            this.updatelogConsumo();
            gtag({ 'event': 'formStep3Submit' });
            this.goPago();
        } else {
          this.validacionSerie = false;
          this.snackBar.open(response.message, "", { duration: this.const.SNACK_BARTIME })
          this.muestraCotizaciones();
        }

      }
    )
    } else  if (cocheSeguro.cia === 20){
      this.requestService.postRequest({ projectName: new Configuration().URLQUATTROAXA, apiName: 'publics/validacion-numero-serie', dataJSON: params, contentType: ('application/json') }).pipe(finalize(() => this.isLoading = false)).subscribe(
        response => {
          if(response.error) {
            this.validacionSerie = false;
            this.snackBar.open(response.error, "", { duration: this.const.SNACK_BARTIME })
          } else if (response.valid) {
              this.validacionSerie = true;
              let cocheSeguro: CocheSeguro = new CocheSeguro();
              if (this.storageService.ifExist("cocheSeguro")) {
                cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
              }
              if ((this.cia == 49 || this.cia == 1) && this.conductor.fec_nac != '') {
                let arr: Array<string> = this.conductor.fec_nac.split('/');
                if (arr.length == 3) {
                  this.conductor.fec_nac_str = arr[2] + '-' + arr[1] + '-' + arr[0];
                }
              }
              if (!this.conductor.mismo_conductor) {
                this.conductor.nombres = this.dataContratante.nombres;
                this.conductor.ap_pat = this.dataContratante.ap_pat;
                this.conductor.ap_mat = this.dataContratante.ap_mat;
                this.conductor.rfc = cocheSeguro.contratante.rfc;
                this.conductor.fec_nac_str = cocheSeguro.contratante.fec_nac_str;
                this.conductor.fec_nac = cocheSeguro.contratante.fec_nac;
              }
          
              cocheSeguro.vehiculo = this.vehiculo;
              cocheSeguro.conductor = this.conductor;
              
              this.storageService.setItem("cocheSeguro", JSON.stringify(cocheSeguro));
              this.updatelogConsumo();
              gtag({ 'event': 'formStep3Submit' });
              this.goPago();
          } else {
            this.validacionSerie = false;
            this.snackBar.open(response.message, "", { duration: this.const.SNACK_BARTIME })
            this.muestraCotizaciones();
          }

        }
      )
    } else {
      this.validacionSerie = true;
      let cocheSeguro: CocheSeguro = new CocheSeguro();
      if (this.storageService.ifExist("cocheSeguro")) {
        cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
      }
      if ((this.cia == 49 || this.cia == 1) && this.conductor.fec_nac != '') {
        let arr: Array<string> = this.conductor.fec_nac.split('/');
        if (arr.length == 3) {
          this.conductor.fec_nac_str = arr[2] + '-' + arr[1] + '-' + arr[0];
        }
      }
      if (!this.conductor.mismo_conductor) {
        this.conductor.nombres = this.dataContratante.nombres;
        this.conductor.ap_pat = this.dataContratante.ap_pat;
        this.conductor.ap_mat = this.dataContratante.ap_mat;
        this.conductor.rfc = cocheSeguro.contratante.rfc;
        this.conductor.fec_nac_str = cocheSeguro.contratante.fec_nac_str;
        this.conductor.fec_nac = cocheSeguro.contratante.fec_nac;
      }
  
      cocheSeguro.vehiculo = this.vehiculo;
      cocheSeguro.conductor = this.conductor;
      
      this.storageService.setItem("cocheSeguro", JSON.stringify(cocheSeguro));
      this.updatelogConsumo();
      gtag({ 'event': 'formStep3Submit' });
      this.goPago()
    }
  }

  back() {
    if (this.const.PLATFORM) {
      window.location.href = this.const.URLPLATFORM + 'datos-emision';
    } else {
      this.router.navigate(['datos-emision']);
    }
  }

  public fecNacimientoMask: any = {
    mask: [
      {
        mask: '00/00/0000',
        regex: '^[0-9]{2}[\/][0-9]{2}[\/][0-9]{4}$'
      }
    ]
  };

  generaRFC(input?: number) {
    if (input && this.cia == 18) {
      //ASDREW
      this.isMismaEdad();
    }
    this.conductor.fec_nac_str = this.conductor.fec_nac.split("/")[2] + '-' + this.conductor.fec_nac.split("/")[1] + '-' + this.conductor.fec_nac.split("/")[0];
    let rfcPaso = new ValidaRFC().calcularRFC(this.conductor.ap_pat, this.conductor.ap_mat, this.conductor.nombres, this.conductor.fec_nac_str);
    this.conductor.rfc = rfcPaso;
  }

  updatelogConsumo() {
    this.logConsumoFun.logConsumo();
  }

  updateJson() {
    let cocheSeguro: CocheSeguro = new CocheSeguro();
    if (this.storageService.ifExist("cocheSeguro")) {
      cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
    }
    if ((this.cia == 49 || this.cia == 1) && this.conductor.fec_nac != '') {
      let arr: Array<string> = this.conductor.fec_nac.split('/');
      if (arr.length == 3) {
        this.conductor.fec_nac_str = arr[2] + '-' + arr[1] + '-' + arr[0];
      }
    }
    if (!this.conductor.mismo_conductor) {
      this.conductor.nombres = this.dataContratante.nombres;
      this.conductor.ap_pat = this.dataContratante.ap_pat;
      this.conductor.ap_mat = this.dataContratante.ap_mat;
      this.conductor.rfc = cocheSeguro.contratante.rfc;
      this.conductor.fec_nac_str = cocheSeguro.contratante.fec_nac_str;
      this.conductor.fec_nac = cocheSeguro.contratante.fec_nac;
    }

    cocheSeguro.vehiculo = this.vehiculo;
    cocheSeguro.conductor = this.conductor;

    this.storageService.setItem("cocheSeguro", JSON.stringify(cocheSeguro));

    let parametro = (this.storageService.ifExist("ayuda")) ? 0 : 2;
    this.logConsumoFun.logConsumo(undefined, parametro);
    this.openModalMarcame();
    this.storageService.setItem("ayuda", JSON.stringify(true));
  }

  openModalMarcame() {
    let modalAyuda = this.modal.open(CotizacionAyudaComponent, { disableClose: false });
    modalAyuda.afterClosed().subscribe(result => {
    });
  }

  otroConductor() {
    if (this.conductor.mismo_conductor) {
      this.muestraOtroConcductor = 0;
      this.conductor.nombres = this.dataContratante.nombres + ' ' + this.dataContratante.ap_pat + ' ' + this.dataContratante.ap_mat
    } else {
      this.muestraOtroConcductor = 1;
      this.conductor.nombres = '';
      this.conductor.ap_pat = '';
      this.conductor.ap_mat = '';
      this.conductor.fec_nac = '';
      this.conductor.fec_nac_str = '';
      this.conductor.rfc = '';
    }
  }

  validSerie(event?) {
    try {
      let cocheSeguro: CocheSeguro = new CocheSeguro();
      cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
      //console.log("ValidSerie: ", cocheSeguro);
      switch (cocheSeguro.cia) {
        case 29: // QUALITAS
          if ((this.vehiculo.serie.length > 15 && this.vehiculo.serie.length < 17) || (this.vehiculo.serie.length == 17)) {
            let valiSerie = this.validacionNoSerie.validaNoSerie(this.vehiculo.serie).pipe(finalize(() => this.isLoading = false))
              .subscribe(result => {              
              if (result.ok == true) {
                valiSerie.unsubscribe();
                this.validacionSerie = true;
                this.goPago();
              } else if (result.ok == false) {
                valiSerie.unsubscribe();
                this.snackBar.open("Serie Amparada en Póliza Vigente ", "", { duration: this.const.SNACK_BARTIME })
                this.validacionSerie = false;
                this.muestraCotizaciones();
              } else if (result.error) {
                this.snackBar.open(result.error, "", { duration: this.const.SNACK_BARTIME });
              } else {
                this.snackBar.open("Ocurrió un problema durante el proceso", "", { duration: this.const.SNACK_BARTIME });
              }
            });
          }
          this.validacionSerie = true;
          break;
        default:   // CHUBB //HDI  // mapfre // Afrime //primero //
          if ((this.vehiculo.serie.length > 15 && this.vehiculo.serie.length < 17) || (this.vehiculo.serie.length == 17)) {
            this.validacionSerie = true;
            this.next();
          } else {
              this.validacionSerie = false;
          }
          break;
      }
    } catch (Error) {
      console.error("Error: ", Error);
    }
  }

  public validarContrasena(): void {
    if (this.dataProspecto.contrasena !== "" && this.dataProspecto.confirmar !== "") {
      if (this.dataProspecto.contrasena !== this.dataProspecto.confirmar) {
        this.dataProspecto.contrasena = "";
        this.dataProspecto.confirmar = "";
        this.snackBar.open("¡La contraseña no coincide!", "Favor de capturar la misma contraseña.", { duration: this.const.SNACK_BARTIME });
      }
    }
  }

  /*CalculateAge(): number {
    if (coche) {
      var timeDiff = Math.abs(Date.now() - this.datosDTO.datosPersonales.fechaNacimiento);
      return Math.ceil((timeDiff / (1000 * 3600 * 24)) / 365);
    } else {
      return null;
    }
  }*/

  muestraCotizaciones() {
    /*if(this.validSerie) {
      const  dialofRef  = this.modal.open(OpcionesSeguros, {
        height: 'auto'
      });

      dialofRef.componentInstance.noSerie = this.vehiculo.serie;
    }*/
  }

  goPago() {

    if(this.conductorRef.value && window.location.hostname == 'cochesegurosivale.inter.mx' || this.conductorRef.value && window.location.hostname == 'cocheseguro.inter.mx' || this.conductorRef.value && window.location.hostname == 'inter-autos-qa.web.app' || this.conductorRef.value && window.location.hostname === 'localhost') {
      this.conductor.ref = this.conductorRef.value;            
    } 

    this.conductor.cod_promocion = this.mostrarCodigoPromocion ? (this.codPromocion.value || '') : '';
    
    this.saveCocheseguroInfo();
    
    let cocheSeguro: CocheSeguro;
    if(this.storageService.ifExist("cocheSeguro")) {
      cocheSeguro = JSON.parse(this.storageService.getItem('cocheSeguro'));
      if (!this.conductor.mismo_conductor) {
        this.conductor.nombres = this.dataContratante.nombres;
        this.conductor.ap_pat = this.dataContratante.ap_pat;
        this.conductor.ap_mat = this.dataContratante.ap_mat;
        this.conductor.rfc = cocheSeguro.contratante.rfc;
        this.conductor.fec_nac_str = cocheSeguro.contratante.fec_nac_str;
        this.conductor.fec_nac = cocheSeguro.contratante.fec_nac;
      }
      cocheSeguro.vehiculo = this.vehiculo;
      cocheSeguro.conductor = this.conductor;
      this.storageService.setItem("cocheSeguro", JSON.stringify(cocheSeguro));

      if(this.validSerie)  {
        if(((cocheSeguro.cia != 14 && cocheSeguro.cia == 18) || this.formaPago === 'T' || this.formaPago === 'M')
        || (cocheSeguro.cia == 14 && this.formaPago === 'T' || cocheSeguro.cia == 14 && this.formaPago === 'M') || cocheSeguro.cia == 20 || cocheSeguro.cia == 44 || cocheSeguro.cia == 3) { //HDI Sólo acepta pago en ventanilla con semestral
          if (this.const.PLATFORM) {
            window.location.href = this.const.URLPLATFORM + 'datos-tarjeta';
          } 
          this.router.navigate(['datos-tarjeta']);
        } else {
          this.router.navigate(['opciones-pago'], { queryParams: { aseg: cocheSeguro.cia } });
        }
      }    
    } 
  }


  nextStep() {
    this.isLoading = true;
    this.saveCocheseguroInfo();
    this.validSerie();
  }

  saveCocheseguroInfo() {
    let cocheSeguro: CocheSeguro = new CocheSeguro();
    cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));

    if (!this.conductor.mismo_conductor) {
      this.conductor.nombres = this.dataContratante.nombres;
      this.conductor.ap_pat = this.dataContratante.ap_pat;
      this.conductor.ap_mat = this.dataContratante.ap_mat;
      this.conductor.rfc = cocheSeguro.contratante.rfc;
      this.conductor.fec_nac_str = cocheSeguro.contratante.fec_nac_str;
      this.conductor.fec_nac = cocheSeguro.contratante.fec_nac;
    }
    cocheSeguro.vehiculo = this.vehiculo;
    cocheSeguro.conductor = this.conductor;
    cocheSeguro.prospecto = this.dataProspecto;
    this.storageService.setItem("cocheSeguro", JSON.stringify(cocheSeguro));
  }
 
  verificaNumeroSerie(numSerie: string): boolean | void {

  }

   keyPressSoloNumeros(event: KeyboardEvent, value: string) {
    
    if (
      event?.key == '0' ||
      event?.key == '1' ||
      event?.key == '2' ||
      event?.key == '3' ||
      event?.key == '4' ||
      event?.key == '5' ||
      event?.key == '6' ||
      event?.key == '7' ||
      event?.key == '8' ||
      event?.key == '9' ||
      event?.key == '.' ||
      event?.keyCode == 48 ||
      event?.keyCode == 49 ||
      event?.keyCode == 50 ||
      event?.keyCode == 51 ||
      event?.keyCode == 52 ||
      event?.keyCode == 53 ||
      event?.keyCode == 54 ||
      event?.keyCode == 55 ||
      event?.keyCode == 56 ||
      event?.keyCode == 57 ||
      event?.keyCode == 46
    ) {
        (<HTMLInputElement>event.target).value =
          (<HTMLInputElement>event.target).value;

    } else {
      event.preventDefault();
    }
  }

  
  validaEspacionVacios(event: KeyboardEvent) {

    if(event?.keyCode === 32 ||  (<HTMLInputElement>event.target).value.length >= 8) {
      event.preventDefault();
    } else {
      (<HTMLInputElement>event.target).value =
      (<HTMLInputElement>event.target).value;
    }

  }

  workParams() {
    this.requestService.getRequest({ 
      projectName: new Configuration().URLPOLIZAS, 
      apiName: 'WorksiteParametroByArrParametroStrAPI', 
      params: [{ 'f1': "300" }, { 'f2': new Configuration().worksiteId }] 
    }).subscribe((response: Array<any>) => {
      try {
        if (Array.isArray(response) && response.length > 0) {
          const valorStr: Array<ValorCodigoPromocion> = JSON.parse(response[0]['valorStr']);
          const valor = valorStr.find((item) => item.hostname == window.location.hostname);

          if (valor) {
            this.mostrarCodigoPromocion = !!valor.promocionActiva;
          }
        }
      } catch (error) {
        console.error("error", error);
      }
    }, (error) => {
      console.error('error', error);
    });
  }

  validacionSerieCoche(){
    if(this.vehiculo.serie !='' && this.vehiculo.serie.length !=this.const.cocheLimiteSerie){
    this.placeholderMessageSerie = "*Ingrese una serie de 17 caracteres"
    this.vehiculo.serie = '';
    this.numSerie = false;
  }else
  if(this.vehiculo.serie !='' && this.vehiculo.serie.length === this.const.cocheLimiteSerie){
      this.numSerie = true;
  } else{
    this.placeholderMessageSerie = "*Ingrese una serie de 17 caracteres"
    this.vehiculo.serie = '';
    this.numSerie = false;
  }
}

focusSerieCoche(){
  this.placeholderMessageSerie = ""
  if(!this.numSerie){
    this.numSerie = true;
  }
}

validacionPromo(text){
      let valor = this[text].value;
      let hoy = new Date();
      let banderaCodigo = false;
      let banderaFecha = false;

      let codigosPromo = [
        {
          codigo : "AMAZONOCT",
        fechaIni :  "2021-10-12",
        fechaFin : "2021-10-17 23:59"
        },
        {
         codigo : "SIVALEINTER500",
        fechaIni :  "2021-08-16",
        fechaFin : "2021-10-31 23:59"
        },
        {
          codigo : "CONTIGOCHECO",
         fechaIni :  "2021-11-29",
         fechaFin : "2021-12-12 07:00"
         },
         {
          codigo : "INTERBUENFIN",
         fechaIni :  "2021-11-10",
         fechaFin : "2021-11-16 23:59"
         },
         {
          codigo : "INTERBLACK",
         fechaIni :  "2021-11-23",
         fechaFin : "2021-11-29 23:59"
         },
         {
          codigo : "ATLASCAMPEON",
         fechaIni :  "2021-11-29",
         fechaFin : "2021-12-04 21:00"
         },
         {
          codigo : "CONTIGORENOVACION",
         fechaIni :  "2021-12-09",
         fechaFin : "2021-12-31 23:59"
         },
         {
          codigo : "HOLIDAYS",
         fechaIni :  "2021-12-13",
         fechaFin : "2021-12-19 23:59"
         },
         {
          codigo : "INTER300",
         fechaIni :  "2021-12-13",
         fechaFin : "2021-12-31 23:59"
         },
         {
          codigo : "INTER1000",
         fechaIni :  "2021-12-13",
         fechaFin : "2021-12-31 23:59"
         },
         {
           codigo : "INTERENERO",
           fechaIni :  "2022-01-03",
           fechaFin : "2022-01-31 23:59"
         },
         {
            codigo : "FEBRERO2022",
            fechaIni : "2022-02-01",
            fechaFin : "2022-02-07 23:59"
         },
          {codigo:	"ISRAEL.ZAM.J42"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RGALICIA.ASESORPEIS26"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DAHVITS152"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ISAIAS18"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RENE.CAPETILLO35"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FERNANDO.MORALES.ROD74"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"IESPINOZA43"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GERARDO.FONSECA39"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JCARAGON7621"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ARAC25"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JAVIERVILLEGAS.MEXICO83"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JAASIELMP368"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALDOAYGONZALEZ28"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"VICMAN53K41"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GVILLERIAS28"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"NATHCP8282"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GILANAV99"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"EMMAGABI197888"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"HECTORCASMED10"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JOSE_ELIAS_BR85"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JESSALOPI96"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"BLANCAYADIRAMG41"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PILAR_434389"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GONZALEZ.Y.N69"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ROMAN.RENTERIA322"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"AYMEE.SANTII88"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"YANNDUHART77"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"START92"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MONSTRIVEL16"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CARLOSPEREZMONT78"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JONATHANJMNZM4035"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"KOG19"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FRANCOMEJIA84919"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GINAZAYAS36"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CPERDOMO50"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JCAPISTRAN74"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"BETOMARZOLI51"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JOSERAMONMN23"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ADRIANGAMEZ191935"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ARMANDO212665"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JESUSLAU25"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"HIDALGRF88"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"KALVARADOGA58"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALEJANDRABO220934"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RAULQ195429"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FJAVIER_GV31"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RAMIROPRADO25276"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JDAVEALAN17"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ROBE.D.O.2319"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JMCORREA4434"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FAINCITO8729"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CIRO156_748"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"VICTORTORIS63"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JONATHAN.CHAVEZ80"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"BRAULIO_361275"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"IORTEGA_45627"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LEEONARDOGUERRERO88"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALEX0233DANFER54"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RGUILLEN65777"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CLARALUZ_341570"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GMTENG20"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SERG.TOXTLE49"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JULIADAIA1750"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GABRIEL.05239"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"AGV811041"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MACHUCAGARCIAFAUSTINO48"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DEBUENARAIZ84"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALEX24048543"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PEPEEMS74"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"VICTOR7.TELLO57"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARYPEDEL60"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ANGIE.MG87"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SKAR067357"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"HERIK1023"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ISRAELNAVARRETE150474"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JORGEPLIEGOM72"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GINA_FCA71"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RDELATORRE17"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"AQUIROZ611"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GARCIAARIASLUCIANO12"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ISAYCVC18"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"HAHNEMANN87"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MG.ESCI79"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"E.MARIANA9844"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DACV32184"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PERA_6589"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SANTIAGOLEZ93"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GLORIALEON2018TORRES81"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CHARRITO13_679"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SAUL_P5442"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MAR_ESTRADA160138"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"VOICEJOGGER99"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DOCGUSTA278"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CAROLINA.NUMATA82"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FORASTERO128165"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ELLY.GTZ94"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JOAQUIND6746"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALEXELHUANTZI97"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GABOMAESTRIA48"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JOSEJUANMC79"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"VICTORLEYVA1066"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"BETOSETIEN25"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RICARDO_HERNAV73"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"HGC25M97"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JORGEVSOMBRA28"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALEXANDER_CTE71"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARY.FE6571"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"EFIMATA8099"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RICARDOALAVEZ969744"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MANUEL.HDZGARCES26"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"BIOLOGOMANUEL.MG53"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SANTOSGA96"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RICARDOM.FRANCISCO72"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JAVIERCARDES81"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RUTH.BLAS40"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MALERI3070"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DAVIDLEONICO43"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MEZAGINGULISES43"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SANTI.MARIAN202589"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SALUSTRIO197892"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CHIVIS006554"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LUKIS_PEKE13"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JUANDEMIGUEL2263"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"M.LINARES28"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ERICK.OLIVAS.ROMERO12"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PUBLI.NAVA71"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MDELALONGAFLORES88"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ARTURO.ORTIZ091730"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"XAIL2680"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RCH41"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"8.DAVILA36"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FERNANDO.OP2479"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"HELIOGZ63"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"AGUILAR.C.GOMEZ46"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"TOCHAMAKEN20"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JDH_THEBEST75"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DIANAL34C666"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GUMAZ99"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARISOLBARROSO18"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MSARAIS2578"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JRIVERA33"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ISAAC.MAURICIOPL53"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"7MZAVALA84"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"EDGARGARCIALOPEZ242438"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JAZNETH70"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JAVIER.CORTEZ36038"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PEDROESPADAS178"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DERECHOCRIMINALISTICA11"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LFAP8564"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CHELALONSO70"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CARLOS.ARMANDO37713"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"AMTZGLEZ77"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"EFRENJIMM_7592"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JORGECARVALLO8731"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DEBORAH_DCO29121015"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CESARPUNTOMX97"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ANGSAFRA88"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"COCOMR90"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DAVIDMORENOGARCIA2431"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LEONARDOGOREL2064"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ADNROMASKA98"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DIEGOSANCHEZBAILON67"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JOSUEANGUIANO66"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SANTIAGO.EGUIA47"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LUISENRIQUE.PVILCHIS44"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LEMN09069068"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MEMD2047"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LUISADRIAN_MENESES68"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PAKER8P68"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LESMORA201731"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JORGITOORM74"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ANDREI_69391"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"AAGA_2364"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ANGELICAREYES9987"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ROSASSALUD201263"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LUCIO_TILTWWE20"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JIBPANDA99"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"THEKILLERS_JULIO82"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FRANCISCO18119613"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ISRRA.5171"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JULIANCADENALIMAS20"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RAFAELRIZO710"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"TERESASALAZAR200891"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"COLUMBAMONSERRATHAGUNDEZAVILES31"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ESTEBANFLORESROBLES55"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LULOMAY57"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MULTIESPECIALIDADESNEZA75"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"P.ARTUROROCHA89"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALEXZIN2777"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JA_ORIGEL32"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"APEREZ57"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LUISOSCARSOBERANES28"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JVARGAS43"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"J.CORONEL19"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"00451286"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RUIV356"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GAF_HOLISTER51"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CENONO60"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALBERTO_GRUPO.ASIA60"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"HUGO_GZZ158"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JOSORIJO458957"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DEEKERICARDO38"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JRAG64"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LIZ700319"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALBERTOHAROB55"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALIZ_VILLARREAL19"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"KARLAALVI67990"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALEJANDRO_MEJIAC99"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RAFAEL.MANICA2496"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SANDRAMENDOZAH132"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"OIRBRITO33"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"BEAA48"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MIRANGIELA47"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MINER.12050883"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FERROGO198"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARIAJOSE.JAIMES.A38"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PUERTOPATRON73"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ARAMIFER4588"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARTINHEREDIAGLEZ15"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ASANIRG87"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DAPREDESA96"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PMC59"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"EDMALDONADO.089123"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"REGINACALMUR33"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JAISIELQB96"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ANDDI.BUSTA37"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JORGELUIGI36"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CYN.PULIDO.MAYORAL42"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CHELO.ALE3576"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MERCASY95"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RCUEVAS5075"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"IAN.GLEZ452817"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"NCKLNRS92"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"HIQG8570"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ATORRES80"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ZUMAETAROSA89"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ANMG29"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"IRGARRIOLA55"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"VFVO14"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JOSE_GGQ76"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MIZPA1974"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RICPAREDES174"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GRANADOSELISA83"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"YO_HIPO78"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"VDQ79"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARIO_CARRILLO54"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALEJANDROMOKAY76"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JRMEJORADO36"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JOSELOPEZ010569"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALVM60"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PEDROPREZ84"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JJMOLLA7750"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"VEROCAMUS7119"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"TOYSON78"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"NINITOGANTHAUS40"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SANTOS_CONEJOTE13019180"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DAVID_AGR13"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"HUGO.3369.HVZ61"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CHANAN.SAID49"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JOJIM7937"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARAGARRIDO1931"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MINA.PVE14"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PEDRORAMIREZMTZ3376"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ABALLEST19"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"VIDALANGELICA860"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"BELCENIAPL37"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"VICTOR326MX41"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DELSOTAM78"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JRCERON1333"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RAFAELPANGLO43"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LICGERARDOLOPEZ20"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ANGELES.SUAMOR45"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"HECMIROLA27"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LEOTELEVISA23"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MIGUELITO_290884"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PEVESA197391"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JAUREGUILOMELI0958"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SHIMBER_1627"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"R_RRIVERA62"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DIRECCION38"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"F.MOYOF87"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"VIVIANA.CASTRO55"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"NADIA.MCASARREAL35"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ROCIOLUNA1576"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"AGUILERA551069485814"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CARLOS.URB76112959"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LIZ.SOTO11"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"BARRITA0311"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GABRIELA65"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RAYMONDMR200075"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LUIS_AC023"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PATRICIAPERERAP39"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CES_NAY060452"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ANA_IVAZQUEZ68"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SUPERGATOALDAHE60"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"EVIESCA50"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SONRICARDO1878"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LBGTANYITA0536"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RCTEQUILA57"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"YIZELPADILLA90"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DANISILVADFR95"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LOZBON10"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RAMONSALTO12"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CLAELI.CEMR8820"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MMMARILES96"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"EMMAESTROD42"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ERICK-MALAGON40"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MADEHESAV92"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ERICK.LOYA9246"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JACQUELIN211452"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LARS11081297"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MONSERRATHMARTINEZ230236"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DULCERIAMB50"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"IGNACIO.ROSALESN18"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CARLOS_LOPEZ493"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FMAYCZ91"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RPRADO72"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ENRIQUEDH7211"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DRA.MIRSHAN15"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DOROGA7451"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"AAL46"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ARMAS.0072289"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"KILAAH_65"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RODRIGO123.GH61"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CABRERATOMAS13182"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ACHAVDEZ30"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ERIKKAIRE4940"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CLABIQUIDO84"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"AROOON.PP49"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ARAELIRUIZ53"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JORGE.SERRATOS32"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GUACHO12MX70"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ANELRENDON49"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALECH071069"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"BIBI021254"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"TANIAA230447"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SHAQ_FM943"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MIGUELABOUMRAD36"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JL35404686"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JORGE.LOPEZ12"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FERNANDOJIMENEZLARA5674"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GAESA.MX23"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"NAVA82346"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MXODNANREF23"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ABARAJAS61"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"TEVICAM266"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JOPARUGA13"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LUISNAVARRETEF79"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARIOEPORTILLO23"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ACAPOTE81"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ANTONBR120634"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MANUEL_OM52"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PRG95471"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JMTORCAL31"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PEGOMLEO.197621"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LICFERNANDORUIZ.9559"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"IL_FARFAN_28797"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"KATY_YOHAN64"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"COCODRILOEZ80"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ROYMAYAGARCIA57"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ARTUROCARRALES_8568"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MAVC72"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CHPROD8656"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ERUBEYMACIAS93"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LMCHEMOR79"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CGARGRA96"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GADA1633"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GUILLERMOVARGASCAMP77"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARIBELCAZARES01115"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JAVIERGF10_21"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CAR_MOP68"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"IVAN.RAAF31"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JGOLGORT31"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARXMANU9055"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARTINIKA6620"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GGARIBAY.SECC3679"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARIBEL.CRUZ.698540"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ESANCHEZ28"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RAFAEL586"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"TETOALOHA46"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PCAPUCHINO063"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DUSTPAIN58"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"AZULDIEJOS96"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MONTSE03071050"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"OMAR.ALIY.GONZALEZ99"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LISSIMARLENE9299"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FMCHITO92"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALONSO_PA34"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"TAIDE_GEORGE40"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALMAAMAYA9557"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ADRIAN91"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"NORMALVAREZ.SANCHEZ195468"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RAMON.ALCALA11"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ESVAMI7799"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FCOBECERRA6153"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"EDUARDOETOVAR88"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LLOPEZ55"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALBERTOSCHILLER17"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RICCI_URDAPILLETA46"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MIRISMAR31241"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LALO_RIVER917"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ARMANDO_JUMEX20"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SEUDY.BERNAL70"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"KAT-I74"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"AUGUSTO19666669"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"AGARCIA927357"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"IRVINGTREJO.H14"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SABRINIYA60"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALMAVHP24"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LUIS_OA67"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CASTROGAXFJ56"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"BEATRIZ.IMSSOPORTUNIDADES40"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALEJANDROMARQUEZORTIZ1157"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PAM.PAME31669"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CLAMANBU_7886"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PICAS_JC96"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CESAR.GONI1086"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALBERTHT.OT45"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ARQGOMEZRODRIGUEZ37"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"KVNUCHIHA28"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MAURICIO.GAMEZI74"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARISELA24"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DANIELVARGAS197916"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"REBECAROSASROMERO84"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"OLI_CERVANTES12"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GECAAMALM83"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ESME.SARO32"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ANAID.ASSILEM66"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RAFAEL.SANCHEZG19"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"XIOYBETO201759"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"OSCARHSUEH32034"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALEXOROZCO9134"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PABLO.DATG95"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JAVITER6118"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"POBLETE65"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GALLETA3469"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MOYZAM62"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DIAZROSASJOSUE29"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JACKIEBOUFFIER19"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CESAR.CORTESOSORIO24"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ZAYDA070491"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"WBERNALG17"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"J.BUGALLO72"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JOSESANCHEZM18"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALFONSOELIZONDO62"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ISAACLIRA.9712"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JAGUAR35734"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GREGORIOPOSADASPERALTA13664"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RENETORRES288681"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"KEVYNMARTINEZ7460"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALCAZAR.100756"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CAPEREZ2223"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JAVIER_GONZALEZT56"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MVZMORALES21"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"IVANCHO83"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LUISMARIO361"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MANUELARTURO_CABALLERORO33"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"KENNY_C_L30"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RGARAY_4548"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PERSIANASDAVID21"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"VIMJ200180"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CHIPPER1_136"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"C_JAVIER9821"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JCRINCONPG60"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ANDREAVILLAMILP42"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JESUS201136024176"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MAGPE112273"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"OMARBER12825"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"HEJUVA195"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PCALDERON353"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"YYADD2791"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GRISS9611"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MONJARAZ197938"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MIJANGOSNEZA339"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SARAHI3725423"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ELREY123-N163"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALANARK6981"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"OMARPROVINCIA12"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RUBEN.ESTRADAG77"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SJIMENEZ33"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RTORRESORNELAS13"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"BARUC22"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"KARIVA.MM54"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"IFCPJORGE21"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SEBASTIANCARRILLO3260547"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FERNANDOALB.AQUINOG63"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GUSTAVOHDZL82"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MSALAZARDAWN61"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LUISEDGAR7962"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"POTER_220335"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RMEZESTHER76"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MACLOVIOSANTOS0072711"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"KAM.D.E11"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MAYANIN201965"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"EDNITA_SALINAS44"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PIL.ITUARTE76"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MVZ.GUSTAVOSANCHEZ82"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SAL.MX40"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"STEFANYYY66"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FABYRAM197556"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"IVONNE_LOPEZZ48"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"VALVAZ280437"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ING.FILIHC89"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JOAQUIN.AVALOS.GDL56"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FRUTAMIEL59"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARYAAGH49"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARIA.ROSALESH32"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GABYESCOBEDO_63"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LROSCARE5163"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ISAAC.ZU45"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"VEROQUIROZ_A72"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CCONTRERAS52"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"EDUARDOROSADOCAN.149"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MIROSZURITA40"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JUAN.MENDOZA82"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ANGIE_SAN0123"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ING.LUISALVAREZR94"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ABELCAMPOS178560"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SALGADOBARACARLOS17"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CAVILHER261245"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LICARGUMEDO80"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"TRUKUTRUKU3359"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARCAMEDINA66"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FARECHE25"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GLALO4788140"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"AAAGVS40"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CSFREGOSO88"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CD.JCPC62"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ROSADIAZHER24"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DEMIANSOLIS28"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LUISJUAN_5LT57"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ARTURO.PECSA0133"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SAULGL29"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"EDED755318"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PEDRAZAHUMBERTO2539"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"VICTOR.GARCIA61"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JONATHAN.RODRIGUEZ94"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GUSTAVOLIRA198754"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CHARLY.AGUILAR21"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MIRIAMKIMC11"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MIRNA.MORALES77"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JUDITHGRHN201355"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MECA07078538"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"KARLAVERONICA.UAS11"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"VIINUPE56"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DANYDANIEL00178"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JESUS29.FACTURA79"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JAVS7768"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"NCMA60"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RIVERALOPEZLUISFERNANDO0882"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SAPADORNO42"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CARCAMFER22"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"EDGAR.RIVAS2435"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GUILLENV1662"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"BERNARDOGAB83"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GUEVARA.CARDENAS.14119020"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"YULS.IPN90"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JOSEPH.DEV8917"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"AISF140129"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ERGOSSOL201093"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"KMONTFORT117454"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ANDRACO195997"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JESUSALEJANDRO.JAAD64"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"A.TAVERA8417"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"M_E_NDEZ99"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"TORIBIO8682"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ADIMO9148"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FERNANDO.RAMIREZ75"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALFONSOMARTINEZHERNANDEZ70"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DIANA.LESED83"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MGROSAS0159"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"BRIAM.PAREDES53"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"HDZ.ANTONIO473"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"VPENALOZA87"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ARA-26180"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"AUXPAPEL27"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JOHNCHAMBERSSFO98"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"WL.APARICIO13"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FRIGE7755"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RAFAMZ197597"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"E.VAZ.CARR70"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ARVA97535"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LIZETH2398BR56"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALAIN.BAR150634"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CD.ARMANDO.ORTIZ41"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DENISSECRUZ_14"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JENYFFERHDEZ29"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SEMEEQ60"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALEXISHLORENZO14"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JGCARRILLOR94"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JORGE_YEE28"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JJORGE22067360"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"VARGASL136338"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FPRESTINONI78"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GABYFER06078"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SELENE42433"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"NUNEZCRISTINA6940"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MRTIN_DVLOS92"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ISMET.NEXUS62"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DVOIROL28"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FER38201566"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ADRIAN72"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"WA.DELANGEL36"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PRODUCTOS.NOM86"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GERARLD.OTE97"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LUISFERNANDOTELLEZ2358"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ELCHUBS00153"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LFLOZANO198357"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DIRECCION94"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GIOVANNAJIMENEZ3430"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LRBC5923"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CARLOS65"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"VIALFONSO814"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SOLANO.BRYAN54"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"BOGIWININTHER71"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GERLIZ42"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"BLANCACARRERA7845"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"EDUARDOSAN.SO199543"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MICHELLIZACHA32"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JLEY700181"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RODRIGO.CARRENORAMIREZ66"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"BCAMPOS397"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DAPM12179843"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SOFIAROLDAN42"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FRANCISCOHERNANDEZ16040294"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GONZALODIAZMEDINA0850"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JNF2421"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LSKSSCP31"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MUGROSA311280"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FRANKROYER3554"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JREYCOLIMAN39"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RAUL83"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MATYGERO1048"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"KATO218536"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PBARONA73"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FRJAGARCIA170230"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JMONTEMAYORM93"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PEJAMENI12"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ARCEOJORGE2342"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"EDMUNDO.OLVERA8463"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JOSEFELIXRDZ93"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"IOLVERA48"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DAVID.ALATORRE25"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ROMAN.IBARRA197241"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GLZ.TADEO46"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JACINTACARRAL16"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GPENA37"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ANDREAGRAPHICDESIGNER36"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DIEGODR2281"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"EMMANUEL99002573"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MCARMEN.RODRIGUEZ74"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"VETANIMALITOS.2745"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"TRANSPORTESJGARCIA71"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ATLANTEDOLPHINS40"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALBERTO.REYNA887633"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MIRARO2679"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"OPERACIONES42"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LISISTRATAUFM55"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GRISS.CORTES.CORRAL68"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"HUBERTPALI51"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"REYMAN.MM24"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ESMAS102519"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"EMMALUCIA16"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LIBERMANRODRIGGUEZ13"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"IGNACIO.PUERTA96"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SPLIEGORB63"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"OPERACIONES38"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JMARTINIDOMINGUEZ27"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"VEROZENTELLA22"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LUIGIMF9150"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JOSELUISLEAL21"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ANGELES2020FIN26"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"HECMEXSAN74"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CHIO_DEME66"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MAOV5882"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ROBLERH2172"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DSANTIBER74"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ARIELALBERTO_GARCIA55"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DIEGOVALLE250229"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PRIS_JUA39"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MACIASTORRESD23"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALEXPLORA960748"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CRISGUERR179816"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"BUBIK_REIVAJ61"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DANIELCORRALESCAMACHO99"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ERICKGASCA1323"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ANGELJ.CRUZ99"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CESAR.KALEL4210"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"COPYTOBEBE12314"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ROVOA37"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"BMDC.9383"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"AEBIATAN684"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ANDREACASTELO151"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JMORALESVELEZ040780"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JMAURICIOGRO65"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FERNANDO_MEDINA2054"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"D.RODRIGUEZSIERRA1993"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ANTONIOPACHECOLARES88"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"OMARPORCAYO159"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RAMIROALFAROMX61"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LIC.CZARZA49"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"UJMADRIGAL755"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ELIZABETHALANIS72"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ARNOLDRIOS9826"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JHOANNAMRSG59"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"IVAN.A.MARTINEZ.V54"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JAGGER96592"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GABRIELL205030"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MORSACC21"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ROSYCASTILLO55550"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"OLVJUAN1890"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"KARLA.SALINASG10"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"T_LLANO92"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"EDPEMA6274"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LIC.LEO127"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FONSECAR.LUIS44"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DJUAREZ32"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ISAI.LOPEZ2521"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SADDY311214"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PARRAAREVALOV18"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"NORIHIROTAO.6031"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GERARDO.JURG9141"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"HUGO.CLIENTE31"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JOELRK00752"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALBGMT99"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JUANJOSETAVERA49"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LORENACANDYGM27"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PABOSCHRAM49"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GOSQUI27"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARANGEL98"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"WALTER62"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CARRASCOJESUS81017"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"HCEJACORTES62"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"IMANDU8811"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LUIS.ADOLFO.08079782"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"AMUNOZ59"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MIGUEL.OLIVARES229"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"QUINTASIX86"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"TS.MAYELA.MUNOZ22"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"BASURTO.E81"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"OSCARCENTENOJUAREZ22"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JOSEVENTURA831217"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARCO.ALBARRAN45"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PAVEL.RODRIGUEZM78"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LESLIEEZARAGOZA8396"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MOVE21090381"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FAUSTOGRAPHIC31"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"BELDEN6312"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GARCIA10204047"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SERVICIOSMULTIGAMA36"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GSUUUS51"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LIZLOHDZ95"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JGFRANCO9872"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"KARIM20SAORY2935"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ESTEBAN790558"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GUSTAVOARROYOFLORES46"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARIO1981.MHR68"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RAYJAV1793"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RCORDOVA26"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RODRIGUEZMONROYG737"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GUIGOTAXEL6024"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JOSELUISVALDEZDELGADO49"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"VGV15"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ADOLFOQUEZADALOPEZ88"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"COCO.BRYCE.ART95"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JORGELUIGY77732"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"REY7CABO82"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JONYOI89"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LUCIANA30058960"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CHAVEZTSANCHEZ41"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MOIMAND60"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SYL.GUZ4494"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"AVALERIAHF96"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JAZJIBE62"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FABIOMORANDIN.A14"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RAMISOKAS26"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JUSG13"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ULISES.MARTELL32"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LUIS.ARMANDO.HDEZ70"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"VALENCIACONDEGERARDO57"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MAVCAZA94"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RUDYVICK34"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CARLADCAST92"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ARMANDO.CASASBLANQUET22"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARAISANTANA2868"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FF.VASQUEZM85"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"BETTOAQUINOV99"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"L.RICARDO.PENA11"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MOSQUEDA.JOSEPH1244"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LULA.MUNOZ.ARGOTE88"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GABRIELA.RAMIREZ69"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PEDROAUG1520"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"BERE.JZA77"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DOMINGUEZAMANDA124"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"OSMVAZ1616"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JORGE.OLIVEROS23"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ACUELLAR.G644"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ZAPATACC93"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JUANPABLOMUJICA.AGRO55"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MAYALA21"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ATLASZALDIVAR19"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"TORRESSERGIOGABRIEL594"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"VALADEZ.74V21"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SGARCIA19"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MADAI_HT54"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ETRUJILLO58"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SHALOM026572"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LFRODRIG72"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MAUDEFRANSUA91"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"HELENP_50765"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CHORIRO64"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"AHMV9024"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"AYRTON_JUAREZ1771"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ODIEDM75"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DIANANEGRETE81478"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ADOLFO17797"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MICHELLE290960"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JASSLAW23"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"BETHSAROCHA78"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"NCASTILLO71053"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"KEEP_ON59"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DAVID.APODACA1359"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"TAILORSHOP.GAMA79"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CARLOSMONTUFAR18"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"B3R3.N1C3.C4RR040"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JDELMO6411"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"HANERICH370"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GUSTAVO.ORDAZ52"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GEFIGUER38"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MTORIZSANTIESTEBAN12"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JUANMLOPEZ3M23"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"KARENDORA160483"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"OMARTAK00736"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"INGERICCSON10"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ANTONIO.MEDINA32"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ANDRES.GUERRA.3045"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"HUGO.REYES.CASANOVA51"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SOFIAMEDINAV99"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"BENJAMIN_BALLESTEROS30"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SHERIFFUVM63"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ULISIX5098"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JRAMIREZUCON73"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"EFRAINHC2260"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ARMANDO.MADRID97"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MCUADRIELLO87"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PPGAROSO77"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PAWISMORALES54"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JS680503134"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CONTACTO48"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JOELFRANCO.RUIZ27"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"HEY_DONYCB56"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LAURYT742"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GALICIA.ANA51"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SANDRA:IDALIA91"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RAFAEL.GASCA93"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ROCKDRIGO01784"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ADRIAN.VARGAS91159"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ESPINOSARTROS64"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CHRISSUNG041051"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"IGARRIDOLASTRA99"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RIOSRAY1931"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"TECAMBIENTALMTY52"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"OBLATS71"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MIGUELMEDINAHERNANDEZ68"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DRSAULPA53"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RAULE8275"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"TANIA.ROJO9346"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"VICF2319"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JARAMIREZR779"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PAZVALDEZJ8812"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LICEDITH22"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GOMEZMLUZ814"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"TENAUNO162"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"IVO_00378"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARTINOLI4383"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"EDHORT23190"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JESUS_CANTERO97"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CAMPOSFEREZ9345"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JUANGRIERA97"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARISOLOLVERAPIOQUINTO59"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"INGGALARZAUNAM66"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"INTERMOLCELAYA24"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JOANBELECHE2488"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ANDONIESTRADAAGUILERA74"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FILIRDZ198851"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JORGE.SALA65"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ARMANDOPERALTA212134"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PACOCR8583"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ARIANDBMAC64"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"TELLEZ.X1096"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FERCHRUIZ1623"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SLIZBMW78"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JACOB221231"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"OSCARGARCIAN554"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"20JUANMI0122"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"EDUARDO.IEMDES97"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ADRINA151148"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GTO.RECICLATE67"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"C.ARMANDO17059548"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"TJIMSO92"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"OSOPROAL78"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RGARCIA73"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ELVASANCHEZVELEZ90"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GILBERTO.CAMARILLO81"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LEORVS81"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ANA.GUERRERO82"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"OACHAGOYA50"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FUMM8957"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"HILDAMENES201430"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LINETT.CANTO66"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"VILLARRUEL170736"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LIDER12816"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ANAJOFERRER66"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"NELY.MARINO21"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"BAEZ.NOE35"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"VILLEGASAEM32"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DANICASTANEDA911"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JOGOVACA37"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SKY_741516"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"HIRAMBARRADAS7817"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"AYHLLON7492"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"BETTOSM1264"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MOISES.TERSAL10"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JOATIGRES200091"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"OTRAPAGA40"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JORGE.GONCA9560"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LALOMOON7692"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CEBADAMUNOZ42"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GLEZCA5663"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JORGEAUG1922"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JORGEORTIZNARANJO66"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GAYLAN101087"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"WALTERTOTTI1014"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GUSTAVOHEREDIA30"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SERCH.ALMAZAN52"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FCARSO3148"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"J.ARREOLA.VALENCIA195"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JUAN.MELGOZA85"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CARORAR1270"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ROSA54083030"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"HECTOR.DIAZFRAUSTO52"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PATRICIO.GUTIERREZ72"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALDOLASALLISTA63"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LUC3SITA122138"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MAOORICIO28"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"VIVIANAGUT98"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JPENA13"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"EGIL.CHE0349"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"NANCY.TREJO.GARCIA36"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"TANIAODALISRODRIGUEZNAVA86"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JUANACORTESHERRERA123449"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"VACUNAS.VISAS99"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"REMORFINS23"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CASTROLUQUE1624"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DJUAREZDIAZ85"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"TWEENCORP13"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LILIANADGLEZ278357"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CHS1930"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"KVN.AVALOS30"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"POGA200040"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JPZAZU0211"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SALASGGABRIEL67"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ANAMORENOGARDUNO70"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DORAELIAGODOYANGULO94"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"EOFARRILL184"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"2012EMTS38"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"TRAGOROJO91"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RICARDO.MONRROY.1435"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JORGE.VILLALOBOS72"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JUAN1104ALANIS67"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MITAGG12313"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ANAVEGAFV10"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CZC59"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MIGUELANGELSANCHEZ3061"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MACIASJOSUE58"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"BSOREQUE98"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RICARDOJAVIERMTZO72"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DIANA.NUEVO13"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MMJIA198162"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"KVN.AHP43"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RMQVALDES40"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LARALIRAGABRIEL79"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CHIZCHAZ.90284"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LUIS.ALB.GUZMAN.HDEZ80"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LALOHF175"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"AMADOR.CANAMAR55"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"QUINTANAR.VILLARREAL58"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CARLOSROJAS104727"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"OVIDIO.JOOS46"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GUILLERMO01CV62"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JAROCHO92541"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JENN.SAC91"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"HERFA070979"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ESEQUIEL2L201614"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CORDEROANTONIO3660"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SERGIOSARABIAG196817"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARCO.TALAMANTE948"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MATIASK79248"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"AGABY.LGONZALEZ56"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LUIS.PROCESADORALAM96"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"HEMSANI38"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARGARIT.196313"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DANBATDRUM65"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SITECURIBE33"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DAPH.BONILLA22"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FIKA.ARQUITECTURA97"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MAUROHURTADO8757"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"EVAPRUDENCIO951"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ACMEDINA726"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PEDRO.SANCHEZ078"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"EFRA_CARO66"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DAVIDSIGUENZAC26"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MAGGY18NH17"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARISOLSR56"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALDOALVARADOS2185"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"NORMAJURADOB81"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RDIAZDORANTES26"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"HDZMARIANO20"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MAGH791240"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"AUNEER16"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DANIEL.GUMP200543"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALEJANDRO.DELCUETO57"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GABRIEL.R.ITD87"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PERLA.DELAROSA0077"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"KAT_TOGA79"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GIL.ERWIN2425"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"OSCARSANTAGLEZ17"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MROSARIOT196235"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GUSTAVOSERNA9060"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MMMADRID62"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALLENPUMA1073"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CLAUDIA_400027"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ISIDRO24028385"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FABI19832013200280"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ZAM.COVARRUBIAS50"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LIZESPANA1591"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"TAGLE_581"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CHARLY.LANDIAZ66"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"EDIAZMUR1732"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CLOPEAG29"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FELIX.ALTAMIRANO49"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"HUMBERTOURIBE71"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"EG46411510"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MONTSERRATEB10"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MICHAELNEILMOORE53"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"VICTOR.MENDEZ69"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"EPOULETT24"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ANNRESENDIZ1191"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RMARTINEZ17"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARIOEFRAINH32"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SALVADOR_MORA65"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"EATC.199350"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"AXEL.JARED200296"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"EDGAREDUARDOMORALES149164"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MATIASVC873"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PEREZ ALEMAN0136"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"VMARTINEZ36"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ANGEL.FORTIS97"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CORONALUISJESUS99"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LEONARDO.OLIVER28"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MIYIZ0923"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ARESENDIZ722"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CNOGALES1721"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MONCHO.SAENZ.RSG24"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALEJANDRO44"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ARTUROPS143315"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MIRELES01257293"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JUAN.BRAMBILA52"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JGDURAN020619"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GUALBIST68"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SURANIMX41"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FRANCISCOANGELESDIAZ176"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CANELITO5581"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ANNELITA777526"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CESEMY62917"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"KHERRERAOPM19"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MIGUELBENITEZALBITER5335"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GERARDOMIGUEL151046"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CMORALES89"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"AARON.HERNANDEZ.R11"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LUIS.MORALES14"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SANTANAGONZALEZFELIPEDEJESUS21"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LIZBETH_GARCIA41"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JUAN.DEURQUIDI43"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CMONTERRUBIO25"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MGUTIERR79"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"HELIO.MGH.IE54"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JAYNEMONTIEL43"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SGUZMAN55"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"KARLA.SEGURAMORENO35"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SOLEY.BVM27"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MIGZUB37"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JUANJOSELG18"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALEJANDRO.MILLAN57"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ILSEPTC12"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ABDERMN216"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"HENRIQUE.OLVERA33"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ROOTAX0969"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JPARADA88"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FSC60"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LIC.GONZALOMENDEZ45"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ARMANDO.N82"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FLUIDNOX98"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CORONAEFRAIN221"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PLUCKY16037739"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALEX.LOPEZ.VILLASE81"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"YEZHUAD32"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GUDELIA.ACOSTA16"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ETOO19410"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"KIKECANSALS7740"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CESARVELAV43"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JETEX6551"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ING.GREYES92"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"BRAULIOISAACC78"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ARUAL72200472"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LIC.ALTAIR.EF1254"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"KARLA.LAND.AVALOS99"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ROSAZGABRIEL63"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"HORACIOVM1160"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DANYDTO8211"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GUSTAVOQUNG0516"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LEOCASME7036"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"17OSCARFUERTE80"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"VANEDELAVEGA13"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GERENCIATROPICALPLAYA74"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CAESARSIERRA850"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"KREATOR_8313"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CIVANZAMUDIO99"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JAVIEROYRNEH1094"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SANVILBER56"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"HENRYMAGADAN38"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JOSEAGUERRAV50"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SOTOR07822"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JLMM740093"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FCO.DURAN.FLORES82"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"NETO18117914"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JHUERTA.IEU35"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FREDDYCAMACH14"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DANYMONTESINOS410"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ROSALIA.OPA468"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"YOHANAPAGUEVARA33"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RAUTREY71"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SANDRAVILL198660"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ERIKA.MACEDO65"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GUERREROALF6557"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RAMOS.MAURICIOGLZ24"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARIO_GARCIA0716"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALEGADI7246"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"EDGAR.15088644"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ROGERCARABRE74"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PGARCIA74"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ROTOOOOTO39"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JCHIU61"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FANALUGA2916"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LG.VILLAHERMOSA.ALEXIS65"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARTHANGUIANO6386"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALCOCERGARCIA71"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MEALEJANDRO71"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SALOPEZS26"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PABLOBERNALCASAR51"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"OSCARBRAVOUNE33"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SOLORZANO.PABLO81"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DANIELMENDEZ21"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LUIS2237913"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SEGURODEOSCAR88"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DANFOSS.PCM58"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ARMANDOLD24"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JLOPEZ.ROJAS9289"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RYU.100.JH31"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LUISCATZALCO95"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CARLOSROSASPAEZ87"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JUANFRANCISCOGONZALEZ1357"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MAYRA.CASTILLO25089310"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"OZUNIGA60"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"BRUNOCORREO71"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"VICMAN19413855"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"TCASVAR36"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MANUELEP94"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CSANTOS37"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JCAMBEROSNAVA31"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SCLEMENTE62"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MIGUELRAMIREZLAGOS87"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CARMENG4326"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CLOGIROD75"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"POLGER14"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ESCOBARGLZDANIEL26"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MANLIO.TAPIA17"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ELIAS95VT19"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ANGEL.FLORES51"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LOTMONSALVO53"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CHAKOXMORENO43"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LEJOS5MAS11"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LUNACANOISELA99"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FERFLORESORTIZ13"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ABALCAZAR45"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ROSAELIA20058859"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"IVAAN.FLORES.9250"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JCMANZANARES2089"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SONYLONA.SL55"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LUIGUI.AC94"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"OJGALVANV61"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LLAMASDARIO23"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ENRIQUE.DIAZMTZ62"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JC.PUGA50"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALEJANDRO25088564"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MAHM19"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SAES_MERMA55"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALG19"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LU0RDZ70"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"VICTORMHVILLICANA83"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"BRODOLFO77784"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARK.HERNANDEZ.2727"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"EDUARDO.GONZALEZ288"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ABRAHAM51"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ZADI194542"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JANTONIO:HEDZG24"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARCORMZ.ISD90"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SAYRAPICHARDO59"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SALVADOR.MARAVILLA.A33"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JORGE.GUTIERREZ727"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ACABRERA86"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MILTON.CARLOS.CANCINO75"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"TIRADODP62"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JBARAJAS.FIG39"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ANDREAMSTAGLE16"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SANCHEZ0142"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"HBRIONES201071"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JRGUEZG38"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ACRUZ25"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PEPEYEY1274"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PABLO.ALEX.REYES43"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RAMIREZMONTIELOSCARSAID89"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MAVIMAC0987"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MAXINO24221"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DAVIDANTONIOSANDOVALMARTINEZ95"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LALOSUNSTAR73"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"VENTASJUANMEZA66"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARIAURIBEMC35"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LEGNA1947"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"AINCOMOX1669"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JOCH80567"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FLORESTORRESOMAR4888"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"TGARZON55"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"NANCYTV198236"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DAVID.RUIZ.B9274"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RAMIREZKEVIN12847"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ZAEL199259"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"COLMENAR.CDMX64"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ERIKA_VILLA6290"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARIATH15741"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JACERUBIEL.BRAVO61"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MINISUPERAGUAAZUL69"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"AMIVIUSS88"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALFREDO.AZAMAR.ABSALON90"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"BERE.ZAAVE18"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JORGE.REYES.PADRON93"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JPRECIADOAL57"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DASUAZOM52"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FRANCISCOMONDRAGON12"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"EDITH_CHR52"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALEJANDRO.CHELENF70"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"TIRADORX35"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SERGIUSARIEL1231"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARCORAUL.HERNANDEZ37"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARCODORADOS836476"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"D.VERAB9077"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ANDREMARCANO10"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GARERIVAS44"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FER.ZAAVE72"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"BETOORTIZ087188"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JUAN.EN.HERNANDEZ.MU83"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JESUSTORRESM65"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"VAUTREY14"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JCCAMARGO6580"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LILIANA.MORALES21"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FLAWERS19755780"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DCAMPUZANO44"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LOBSAN28RS99"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CARLOSTOVAR812"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARITZAPINA251073"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FRAORMAC90"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GABRIELA.VALLADOLID.MACIAS80"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JMPICAZOM86"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JOSUEEVG9513"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"UVAS_BAR93"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CHRISTIAN.KLEE1422"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LAAU311285"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MAUGALINDO9568"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"THEMAUJC55"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ELIANEJUAREZ78846"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MORENONANY1221"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"BENITO.SILVA.197087"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"HPARDO6323"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CANSECO_RAUL31"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JVMONTIEL54"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PACOELVIOLINISTA72"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"OBEEDDG26"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALANDTM1996"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ADEANDA90"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"C.BARRAGAN.GON86"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ING.JJNEVAREZ26"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FERNANDOROJASDGO73"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GERARDOABIZAY80"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JUAN.LUNA75"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JLOGAM77"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PETER010MX28"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PEZZ12090520"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LUIS63"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LP.MGOMEZ70"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SANTIAGOJJF8174"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"AIDEE1110P_31"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RICFMX73"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RDLM53"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JOSELUIS.CASTILLO68"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ARUAL169193"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ARIELG.SONRISAG81"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FPORRAGAS23"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ADABHOGAR54"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GERARDOROSAS.ARCE14"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ADOLFOSALGADO69"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"XBR85"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DANILEON272344"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RODRIGO.NATERA8871"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ED.IBANEZ11"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MJMOTORS2539"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ANDRESEMIGDIOMARTINEZ55"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARYKARSANTOS63"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MIRIAMVMTZ8488"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JMOLINAH56"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ILYMEHE180451"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALEX.MALAGON.7387"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CBORGES245762"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ARMANDO.VILLASENOR0367"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LAURAZAMARE97"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ARCOSDEARAGONTHEBEST94"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RESMERALDA88121"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"BOGUS171817"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GCRUZJH45"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ABRAHAMBELTRAN8880"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JOAQUIN14131825"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"TOBYGLEZ9536"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"OSCAR.GONZALEZ19"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JIDPPEPE18"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FABIOKYT721147"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GPE.ZAR89"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RAKELOYO48"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ROSARIO.LOMR2526"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARCO.TORRESE71"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"IS4TORR3S16"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ARQUIMEDES.0710"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ERNESTOCARRASCOCH75"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"YANDIRA.ORTEGA12"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"THEDASUDAN66"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"AGUASALCANTARAJOSE38"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GINARION76"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LILIA.TIERRABLANCAS16"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"NYDIA_MANRIQUE44"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALFARODELA61"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"BREJAZ.2468"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FAUSTO.HTRILLO85"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PATTYROA74"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"XANGELORM81"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LUZDIAZ192949"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GEOVANNI210441"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"AGPAYAN84"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARIVELIP0732"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"IRMA_CB54"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FVELAZQUEZ41"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"OSCAR.AGUILAR75"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MRROMERO50"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALBERTO.ROSENTHAL53"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"EDUARDO.URIBER88"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FDO.RAMOS.DAVILA75"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JESUSAN_GLEZ75"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FRANCISCO16"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"HEGUIS201657"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ARTURO.PEREZ92"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"AEGZZGZZ57"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MAMAPAMECRUZ25"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DIANA.ASSOULINE69"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LAURAGMATA8697"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALFREDOROCA7011"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"TRAVER.RAFAEL60"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MABOUM5051"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JDIAZSAU59"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GCHUELA140"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PINABALLADO8095"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MEMOHDS1184"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"BARRERATELLEZ98"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MALDONADOGCIA.ROBER75"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ARC66"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ERIKAMALI8183"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CORTESLOPEZALEXIS0929"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JNAZARIOBL20"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LUIS.FERNANDO.BOSS59"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MANITO108284"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"TISALVADORGA85"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CPLAPMX39"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DIAN2001AZUL53"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"AGUEDAXIU75"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"TENECI46"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"A.VILLENASANDOVAL39"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PELAYOJAVIER18848"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JASY671279"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JVIDAL.MASTER29"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"YAFET_AMIN66"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JORGEARIAS4738"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MILANEZDANIEL0490"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARIAGONZALEZRA448"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JAVIER.OLVERAA90"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MLP379391"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GUZMANRD99"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ISIS.ELOISA.HERNANDEZ58"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"JAMA_230388"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"IAIH790085"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CORTESAYALA7818"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DIONE.LAZARO76"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"CONTADOR.MAZA25"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LUISITOVERA480"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ANATOLIA042799"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DENISEROSSC71"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ERIKALAGUNAS53"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"EAOA46"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ELPOLLOAGUILA834"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ARMANDOF9284"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RUBI.MEZA88"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"DOMINGOANTONIOSUAREZLOPEZ42"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ALONSO.B.V69"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"FERNANDEZCPILAR87"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ILSEOBERST18"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ABOGADO.ESTEBAN.WALLE58"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"J.ANTONIO.ANAYA9862"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ANDRADE.FAZ.FLAVIO69"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ABEXA353"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SHARK765256"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LYAMAGUTI58560"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SALVADORSF51"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LICOACOME176011"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"MARCMEX238"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"SCANCHOLA18"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"RENATERAS7786"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"AVELLANEDA0028"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"ELIASMORENOH66"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"AGRIFFITHCASTRO72"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"LUISDANIEL.ALVAREZ85"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"PABOSCHRAM49"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {codigo:	"GOSQUI27"	,fechaIni:	"2022-02-15"	,fechaFin:	"2022-03-15 23:59"	},
          {
            codigo : "FEBRERO500",
            fechaIni : "2022-02-16",
            fechaFin : "2022-02-28 23:59"
          },
          {
            codigo : "REFERIDOS02",
            fechaIni : "2022-02-17",
            fechaFin : "2022-02-28 23:59"
          },
          {
            codigo : "ATLAS20",
            fechaIni : "2022-03-01",
            fechaFin : "2022-04-01 20:59"
          },
          {
            codigo : "VENTAS61",
            fechaIni : "2022-02-21",
            fechaFin : "2022-02-28 23:59"
          },
          {
            codigo : "SIVALE2022",
            fechaIni : "2022-03-01",
            fechaFin : "2022-03-31 23:59"
          },
          {
            codigo : "COMPARTAMOS2022",
            fechaIni : "2022-03-01",
            fechaFin : "2022-03-31 23:59"
          },  
          {
            codigo : "INTERMUJER",
            fechaIni : "2022-03-07",
            fechaFin : "2022-03-13 23:59"
          }, 
          {
            codigo : "CHECOLEYENDA",
            fechaIni : "2022-03-21",
            fechaFin : "2022-03-27 10:59"
          }, 
          {
            codigo : "RACINGTEAM",
            fechaIni : "2022-03-22",
            fechaFin : "2022-03-27 10:59"
          }, 
          {
            codigo : "RWUPSIVALE",
            fechaIni : "2022-03-24",
            fechaFin : "2022-03-27 10:59"
          }, 
          {
            codigo : "MARZO500",
            fechaIni : "2022-03-28",
            fechaFin : "2022-03-31 23:59"
          },
          {
            codigo : "ATLAS2O",
            fechaIni : "2022-03-28",
            fechaFin : "2022-04-02 16:59"
          }  
        ]

       let codigos = codigosPromo.filter(codigos => codigos.codigo === valor);

        let arrayVacio = codigos.length;
        if(arrayVacio != 0){
          for (let i=0; i < codigos.length; i++) {
            if(codigos[i].codigo == valor){
              let fechaIni = new Date(codigos[i].fechaIni);
              let fechaFin = new Date(codigos[i].fechaFin);
              if( hoy > fechaIni && hoy < fechaFin){
                 banderaFecha = true;
              }else if(hoy > fechaIni && hoy > fechaFin){
                  if(codigos.length == i+1){
                    this.snackBar.open("Este código no está activo, revisa inter.mx/promos para verificarlo.", "", {
                    duration: 4000,
                    horizontalPosition: "center",
                    verticalPosition: "top",
                    panelClass: ["custom-style"]
                      });
                    this[text] = new FormControl('');
                  }
                }
           }
          }
        }else{
          this.snackBar.open("El código que escribiste no existe, revisa inter.mx/promos para verificarlo.", "", {
          duration: 4000,
          horizontalPosition: "center",
          verticalPosition: "top",
          panelClass: ["custom-style"]
          });
          this[text] = new FormControl('');
        }
    }
  }

